module.exports = __webpack_public_path__ + "static/media/modalImg8.20213982.png";